if (!customElements.get('media-gallery')) {
  customElements.define('media-gallery', class MediaGallery extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        liveRegion: this.querySelector('[id^="GalleryStatus"]'),
        viewer: this.querySelector('[id^="GalleryViewer"]'),
        thumbnails: this.querySelector('[id^="GalleryThumbnails"]')
      }
      this.mql = window.matchMedia('(min-width: 750px)');
      if (!this.elements.thumbnails) return;

      this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
      this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch,index) => {
        mediaToSwitch.querySelector('button').addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false,index)
      );
      });
      if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
      this.prevButton = this.querySelector('.media-gallery__custom-buttons button.prev')
      this.nextButton = this.querySelector('.media-gallery__custom-buttons button.next')
      this.currentSlide = +this.querySelector('.media-gallery__custom-buttons .slide-current').innerHTML
      this.totalSlide = +this.querySelector('.media-gallery__custom-buttons .slide-total').innerHTML
      this.currentSlideEl = this.querySelector('.media-gallery__custom-buttons .slide-current')
      this.allThumbNails = this.elements.thumbnails.querySelectorAll('[data-target]')

      this.initCustomButtons()
    }

    onSlideChanged(event) {
      const thumbnail = this.elements.thumbnails.querySelector(`[data-target="${ event.detail.currentElement.dataset.mediaId }"]`);
      this.setActiveThumbnail(thumbnail);
    }

    setActiveMedia(mediaId, prepend,index) {
      const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${ mediaId }"]`);
      this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
        element.classList.remove('is-active');
      });
      activeMedia.classList.add('is-active');

      if (prepend) {
        activeMedia.parentElement.prepend(activeMedia);
        if (this.elements.thumbnails) {
          const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
          activeThumbnail.parentElement.prepend(activeThumbnail);
        }
        if (this.elements.viewer.slider) this.elements.viewer.resetPages();
      }

      this.preventStickyHeader();
      window.setTimeout(() => {
        if (this.elements.thumbnails) {
          activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
        }
        if (!this.elements.thumbnails || this.dataset.desktopLayout === 'stacked') {
          activeMedia.scrollIntoView({behavior: 'smooth'});
        }
      });
      this.playActiveMedia(activeMedia);

      if (!this.elements.thumbnails) return;
      const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
      this.setActiveThumbnail(activeThumbnail);
      this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
      this.currentSlideEl.innerHTML = index + 1
      this.currentSlide = index + 1

      if(this.currentSlide === 1){
        this.prevButton.disabled = true
      }

      if(this.currentSlide === this.totalSlide){
        this.nextButton.disabled = true
        this.prevButton.disabled = false
      }

      if(this.currentSlide < this.totalSlide){
        this.nextButton.disabled = false
      }

      if(this.currentSlide > 1){
        this.prevButton.disabled = false
      }
    }

    setActiveThumbnail(thumbnail) {
      if (!this.elements.thumbnails || !thumbnail) return;

      this.elements.thumbnails.querySelectorAll('button').forEach((element) => element.removeAttribute('aria-current'));
      thumbnail.querySelector('button').setAttribute('aria-current', true);
      if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

      this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
    }

    announceLiveRegion(activeItem, position) {
      const image = activeItem.querySelector('.product__modal-opener--image img');
      if (!image) return;
      image.onload = () => {
        this.elements.liveRegion.setAttribute('aria-hidden', false);
        this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace(
          '[index]',
          position
        );
        setTimeout(() => {
          this.elements.liveRegion.setAttribute('aria-hidden', true);
        }, 2000);
      };
      image.src = image.src;
    }

    playActiveMedia(activeItem) {
      window.pauseAllMedia();
      const deferredMedia = activeItem.querySelector('.deferred-media');
      if (deferredMedia) deferredMedia.loadContent(false);
    }

    preventStickyHeader() {
      this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
      if (!this.stickyHeader) return;
      this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
    }

    removeListSemantic() {
      if (!this.elements.viewer.slider) return;
      this.elements.viewer.slider.setAttribute('role', 'presentation');
      this.elements.viewer.sliderItems.forEach(slide => slide.setAttribute('role', 'presentation'));
    }

    initCustomButtons(){
      if(!this.prevButton || !this.nextButton) return
      this.prevButton.addEventListener('click',()=>{
        console.log('left',this.currentSlide)
        this.nextButton.disabled = false;
        if(this.currentSlide  === 1){
          return
        }

        if(this.currentSlide <= this.totalSlide){
          this.currentSlide-=1
          
        }

        if(this.currentSlide === 1){
          this.prevButton.disabled = true
        }

        this.allThumbNails[this.currentSlide - 1].querySelector('button').click()

        console.log(this.currentSlide - 1, this.allThumbNails[this.currentSlide - 1])
        this.currentSlideEl.innerHTML = this.currentSlide
      })

      this.nextButton.addEventListener('click',()=>{
        console.log('right',this.currentSlide);
        
       
        this.prevButton.disabled = false;
        if(this.currentSlide  === this.totalSlide){
          return
        }

        if(this.currentSlide < this.totalSlide){
          this.currentSlide+=1
        }

        if(this.currentSlide  === this.totalSlide){
          this.nextButton.disabled = true;
        }

        this.allThumbNails[this.currentSlide - 1].querySelector('button').click()
        this.currentSlideEl.innerHTML = this.currentSlide
      })
    }
  });
}



// Function to initialize a slider
function initializeSlider(sliderWrapper) {
  // Get the slider elements for the current wrapper
  const prevButton = sliderWrapper.querySelector('.media-gallery__custom-buttons .prev');
  const nextButton = sliderWrapper.querySelector('.media-gallery__custom-buttons .next');
  // const thumbnailList = sliderWrapper.querySelector('.thumbnail-list');
  // const galleryList = sliderWrapper.querySelector('.product__media-list');

// Add event listeners for mouse clicks
prevButton.addEventListener('click', function() {
  prevButton.focus(); // Add focus on the prev button
});

nextButton.addEventListener('click', function() {
  nextButton.focus(); // Add focus on the next button
});

// Function to go to the previous slide
function goToPrevSlide() {
  prevButton.click();
  prevButton.focus();
}

// Function to go to the next slide
function goToNextSlide() {
  nextButton.click();
   nextButton.focus();
}

// Event listener for the keyboard arrow keys
document.addEventListener('keydown', function(event) {
  if (event.key === 'ArrowLeft') {
    // Left arrow key: go to the previous slide
    goToPrevSlide();
  } else if (event.key === 'ArrowRight') {
    // Right arrow key: go to the next slide
    goToNextSlide();
  }
});

  
// Function to add focus-visible class if the button is not disabled
function addFocusVisibleClass(button) {
  if (!button.hasAttribute('disabled')) {
    button.classList.add('focus-visible'); // Add 'focus-visible' class if not disabled
  }
}

// Event listeners to add 'focus-visible' when focused and not disabled
prevButton.addEventListener('focus', function() {
  addFocusVisibleClass(prevButton);
});

nextButton.addEventListener('focus', function() {
  addFocusVisibleClass(nextButton);
});

// Optionally, remove the class when the button loses focus
prevButton.addEventListener('blur', function() {
  prevButton.classList.remove('focus-visible');
});

nextButton.addEventListener('blur', function() {
  nextButton.classList.remove('focus-visible');
});


   // Add tabindex for keyboard focus
  sliderWrapper.setAttribute('tabindex', '0');
}

// Initialize all sliders on the page
const sliders = document.querySelectorAll('.media-gallery-wrapper');
sliders.forEach(initializeSlider);



//add focus on slider
document.addEventListener("keydown", (event) => {
  const thumbnails = document.querySelectorAll(
    '.thumbnail-list.list-unstyled.slider .thumbnail'
  ); // Select all thumbnail buttons
  const currentThumbnail = document.querySelector(
    '.thumbnail-list.list-unstyled.slider .thumbnail[aria-current="true"]'
  ); // Find the current active button

  if (!currentThumbnail) return; // If no active thumbnail, do nothing

  const currentIndex = Array.from(thumbnails).indexOf(currentThumbnail);
  let newIndex;

  if (event.key === "ArrowRight") {
    // Navigate to the next thumbnail
    newIndex = (currentIndex + 1) % thumbnails.length; // Loop back to the first thumbnail
  } else if (event.key === "ArrowLeft") {
    // Navigate to the previous thumbnail
    newIndex = (currentIndex - 1 + thumbnails.length) % thumbnails.length; // Loop back to the last thumbnail
  } else {
    return; // Do nothing for other keys
  }

  // Update `aria-current` attribute
  currentThumbnail.setAttribute("aria-current", "false");
  thumbnails[newIndex].setAttribute("aria-current", "true");

  // Move focus to the new thumbnail
  thumbnails[newIndex].focus();
});



// Function to initialize a slider
// function initializeSlider(sliderWrapper) {
//   // Get the slider elements for the current wrapper
//   const prevButton = sliderWrapper.querySelector('.media-gallery__custom-buttons .prev');
//   const nextButton = sliderWrapper.querySelector('.media-gallery__custom-buttons .next');
//   const thumbnailList = sliderWrapper.querySelector('.thumbnail-list');
//   const galleryList = sliderWrapper.querySelector('.product__media-list');

//   // Helper function to toggle the 'focus-visible' class based on the button's state
//   function toggleFocusVisible(button) {
//     if (!button.hasAttribute('disabled')) {
//       button.classList.add('focus-visible'); // Add if not disabled
//       button.focus(); // Set focus to the button
//     } else {
//       button.classList.remove('focus-visible'); // Remove if disabled
//     }
//   }

//   // Helper function to go to the previous slide
//   function goToPrevSlide() {
//     if (!prevButton.hasAttribute('disabled')) {
//       prevButton.click();
//       toggleFocusVisible(prevButton); // Ensure focus-visible is added
//     }
//   }

//   // Helper function to go to the next slide
//   function goToNextSlide() {
//     if (!nextButton.hasAttribute('disabled')) {
//       nextButton.click();
//       toggleFocusVisible(nextButton); // Ensure focus-visible is added
//     }
//   }

//   // Add 'focus-visible' class by default
//   toggleFocusVisible(prevButton);
//   toggleFocusVisible(nextButton);

//   // Event listeners to handle focus and blur for buttons
//   function handleFocusEvents(button) {
//     button.addEventListener('focus', () => toggleFocusVisible(button));
//     button.addEventListener('blur', () => button.classList.remove('focus-visible'));
//   }

//   // Apply focus event handling to buttons
//   handleFocusEvents(prevButton);
//   handleFocusEvents(nextButton);

//   // Event listener for keyboard arrow keys
//   sliderWrapper.addEventListener('keydown', (event) => {
//     if (event.key === 'ArrowLeft') {
//       goToPrevSlide();
//     } else if (event.key === 'ArrowRight') {
//       goToNextSlide();
//     }
//   });

//   // Add tabindex for keyboard focus
//   sliderWrapper.setAttribute('tabindex', '0');

//   // Mouse click focus handling
//   prevButton.addEventListener('click', () => toggleFocusVisible(prevButton));
//   nextButton.addEventListener('click', () => toggleFocusVisible(nextButton));
// }

// // Initialize all sliders on the page
// const sliders = document.querySelectorAll('.media-gallery-wrapper');
// sliders.forEach(initializeSlider);